/* =========================================
   Hover Add to Cart (Collection Thumbnails)
   ========================================= */

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.hover-atc__btn');
  if (!btn) return;

  e.preventDefault();
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: btn.dataset.variantId,
      quantity: 1
    })
  })
  .then(r => r.json())
  .then(() => {
    btn.textContent = '✓ Im Warenkorb';

    // Flex-kompatibel: Cart aktualisiert
    document.dispatchEvent(new CustomEvent('cart:updated'));

    setTimeout(() => {
      btn.textContent = 'In den Warenkorb';
      btn.disabled = false;
    }, 1000);
  })
  .catch(() => {
    btn.textContent = 'Fehler – erneut';
    btn.disabled = false;
  });
});

// Quick Add to cart
document.addEventListener("click", async (e) => {
  const btn = e.target.closest(".quick-add-btn");
  if (!btn) return;

  // Klick nicht an den Produktlink durchreichen
  e.preventDefault();
  e.stopPropagation();

  const isSingle = btn.getAttribute("data-single-variant") === "true";

  // Multi-Variant? -> Quickshop öffnen (Flex kann das)
  if (!isSingle) {
    const wrap = btn.closest(".product-wrap");
    if (wrap) {
      // Flex Quickshop Button in deinem Markup existiert, wenn enable_quickshop=true
      const quickshopBtn =
        wrap.querySelector(".quick-shop__button, .quick-shop-button, [data-quick-shop], button[name='quick_shop']");
      if (quickshopBtn) {
        quickshopBtn.click();
        return;
      }
    }
    // Falls Quickshop Button nicht gefunden wird -> fallback: Produktseite öffnen
    const productLink = btn.closest(".product-image__wrapper")?.querySelector("a[href]");
    if (productLink) window.location.href = productLink.href;
    return;
  }

  // Single-Variant: Ajax Add-to-Cart
  const variantId = btn.getAttribute("data-variant-id");
  if (!variantId) return;

  btn.disabled = true;
  const old = btn.textContent;

  try {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    });

    if (!res.ok) throw new Error("add failed");
    refreshCartUI();

btn.classList.add("is-added");
setTimeout(() => btn.classList.remove("is-added"), 900);


    // Optional: falls Flex Cart Drawer Events hat, könnten wir hier triggern.
    // (Theme-spezifisch)
  } catch (err) {
    btn.textContent = "!";
    setTimeout(() => (btn.textContent = old), 900);
  } finally {
    btn.disabled = false;
  }
});

async function refreshCartUI() {
  try {
    const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());

    // Cart-Counter updaten (Flex / Theme-Varianten)
    const selectors = [
      '.header-cart__count',
      '[data-cart-count]',
      '.cart-badge',
      '.cart_count'
    ];

    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        el.textContent = cart.item_count;
      });
    });

    // Events triggern (falls Flex/Ajax Cart Drawer darauf hört)
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    document.dispatchEvent(new CustomEvent('ajaxCart:refresh', { detail: cart }));
  } catch (e) {
    console.error('refreshCartUI failed', e);
  }
}

 